import React from 'react';
import { COLORS } from '../../config/designSystem/Colors';
import { Caption2Bold } from '../../config/designSystem/typography';
import { EvolunoCheck } from '../../assets/images/Icons/Check/EvolunoCheck';
import { SPACING } from '../../config/designSystem/Spacing';
import { TouchableOpacity } from 'react-native';
import { observer } from 'mobx-react';
import { useStores } from '../../hooks/useStores';

export type MarkAsDoneProps = {
    onPress: () => void;
}

const _MarkAsDone = ({onPress}: MarkAsDoneProps) => {
  const rootStore = useStores();
  const labels = rootStore?.language?.translate?.MOBILE?.HOME;

  return(
    <TouchableOpacity onPress={onPress} style={{
      borderRadius: SPACING['sp-24'],
      borderWidth: SPACING['sp-2'],
      paddingVertical: SPACING['sp-8'],
      paddingHorizontal: SPACING['sp-16'],
      flexDirection:'row',
      columnGap: SPACING['sp-16'],
      borderColor: COLORS.content.accent,
      alignItems:'center'}}>
      <Caption2Bold color={COLORS.content.accent}>{labels?.MARK_AS_DONE}</Caption2Bold>
      <EvolunoCheck color={COLORS.content.accent} size={SPACING['sp-24']} />

    </TouchableOpacity>

  );

};

export const MarkAsDone= observer(_MarkAsDone);